<dcu-add-new-form
  [info]="addInfo"
  (onSave)="addNewItem.onSave($event)"
  (onSaveClose)="addNewItem.onSaveClose($event)"
>
  <omni-cooperative-info [cooperative]="cooperative" [isEdit]="isEdit" #addContent></omni-cooperative-info>
</dcu-add-new-form>

